import { Injectable } from '@angular/core';

import { BaseHttpService } from '@common/services/REST/base.http.service';
import { type Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SessionHttpService extends BaseHttpService {
    public updateSession(): Observable<any> {
        return this.http.get(`/members/index/alive?_=${Date.now()}`, { responseType: 'text' });
    }
}
